import { Component, OnInit } from '@angular/core';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { Title, Meta } from '@angular/platform-browser';
import { MenuEnum } from 'src/app/shared/enum/menu-enum';
import { PlataformaTDSubMenuEnum } from 'src/app/shared/enum/plataforma_td-submenu-enum';
import { HeaderService } from 'src/app/core/services/header.service';
import { Router } from '@angular/router';
import { GoogleAnalyticsService } from 'ngx-google-analytics';

@Component({
  selector: 'app-plataforma-assinatura-eletronica',
  templateUrl: './plataforma-assinatura-eletronica.component.html',
  styleUrls: ['./plataforma-assinatura-eletronica.component.scss']
})

export class PlataformaAssinaturaEletronicaComponent implements OnInit {
  data: any;

  constructor(
    private translate: TranslateService,
    private headerService: HeaderService,
    private titleService: Title,
    private meta: Meta,
    private router: Router,
    private gaService: GoogleAnalyticsService
  ) {
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.carregarDados();
    });
  }

  ngOnInit() {
    this.headerService.carregarSubMenu(MenuEnum.PLATAFORMA_TD, PlataformaTDSubMenuEnum.ASSINATURA_ELETRONICA);
    this.carregarDados();
  }

  carregarDados() {
    this.translate.get('PRINCIPAL.PAGES.PLATAFORMA.PAGES.ASSINATURA_ELETRONICA')
      .subscribe(res => {
        this.data = res;
        this.titleService.setTitle(this.data.HEADER_TITLE);
        this.meta.updateTag({ name: 'description', content: this.data.META_DESCRIPTION });
        this.meta.updateTag({ name: 'keywords', content: this.data.META_KEYWORDS });
        this.gaService.pageView(this.router.url);
      });
  }

}
